export default __webpack_public_path__ + "static/media/sec3.385d6ec2.svg";